<template>
  <div>
    <v-card class="py-3 px-3 mb-3">
      <div class="d-flex align-center justify-space-between mb-3">
        <h4 class="text-uppercase">
          {{ title }}
        </h4>
      </div>

      <div>
        {{ info }}
      </div>
    </v-card>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      default: null,
    },
  },
};
</script>
